<!-- 获取单个停车场基本信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC"
            },
            responseCode: {"data":{"address":"深海路","conTel":"","desc":"","email":"ydt@xxx.com","eptCarports":49,"freeTime":15,"inEntranceNum":0,"isCharge":1,"latitude":"113.14956","longitude":"23.036155","outEntraceNum":0,"parkCode":"2KNTYVWC","parkName":"开发停车场2","totalCarports":100},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取单个停车场基本信息",
                t_url: this.commonUrls.test+"getParkInfo",
                p_url: this.commonUrls.prod+"getParkInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'address', info2: '是', info3: 'String', info4: '停车场地址' },
                        { info1: 'longitude', info2: '是', info3: 'String', info4: '经度' },
                        { info1: 'latitude', info2: '是', info3: 'String', info4: '纬度' },
                        { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'inEntranceNum', info2: '是', info3: 'Integer', info4: '入口数量' },
                        { info1: 'outEntraceNum', info2: '是', info3: 'Integer', info4: '出口数量' },
                        { info1: 'isCharge', info2: '是', info3: 'Integer', info4: '是否收费（0不收费，1收费）' },
                        { info1: 'freeTime', info2: '是', info3: 'Integer', info4: '免费停车时长，单位分钟' },
                        { info1: 'totalCarports', info2: '是', info3: 'Integer', info4: '总车位数' },
                        { info1: 'eptCarports', info2: '是', info3: 'Integer', info4: '空车位数' },
                        { info1: 'conTel', info2: '是', info3: 'String', info4: '联系电话' },
                        { info1: 'email', info2: '是', info3: 'String', info4: '联系邮箱' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkInfo.vue